/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import { FormGroup as ChromaFormGroup } from '@iag-packages/chroma-react/lib/patterns';

import THEME from 'theme';
import { SCREEN } from 'scenes/common/types/screen';

const FormGroupWrapper = styled.div`
  .c-label,
  .c-legend {
    font-size: 1.25em;
    font-weight: 500;
    font-family: 'Avant Garde', century gothic, arial, sans-serif !important;
    @media (min-width: ${SCREEN.SMALL}px) {
      font-size: 1.5em;
    }
  }

  label + p,
  legend + p {
    font-size: 1em !important;
  }
  .p-form-group {
    margin: 0 0 1.5rem;
  }
  .c-icon {
    color: ${THEME.LINK.DEFAULT} !important;
  }
  .c-btn--link {
    color: ${THEME.LINK.DEFAULT};

    &:active {
      background-color: transparent !important;
    }
  }
  .c-message {
    margin-top: 1rem !important;
  }
  .c-message__content {
    .c-text {
      font-weight: 400;
    }
  }
`;

export const FormGroup = ({ ...props }: { [key: string]: object | string }) => (
  <FormGroupWrapper>
    <ChromaFormGroup {...props} />
  </FormGroupWrapper>
);

export default FormGroup;
